import { render, staticRenderFns } from "./AuthController.vue?vue&type=template&id=08adc5d7&scoped=true&"
import script from "./AuthController.vue?vue&type=script&lang=ts&"
export * from "./AuthController.vue?vue&type=script&lang=ts&"
import style0 from "./AuthController.vue?vue&type=style&index=0&id=08adc5d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08adc5d7",
  null
  
)

export default component.exports